import React from "react";
import { Grid, Box } from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import "react-responsive-carousel/lib/styles/ca"
import { Carousel } from "react-responsive-carousel";
import FlightBooking from "../../assets/images/FlightBooking.jpg";
const CarouselBottom = () => {
  return (
    // autoPlay infiniteLoop
    <Carousel autoPlay infiniteLoop>
      {[0, 1, 2, 3].map((i) => {
        return (
          <Grid container spacing={2} style={{ marginTop: 50 }}>
            <Grid item xs={12} sm={6}>
              <Grid container>
                <Grid
                  item
                  xs={8}
                  style={{
                    border: "2px solid #dfdfdf",
                    padding: "10px 65px 10px 10px",
                    borderRadius: 9,
                  }}
                >
                  <Box>
                    <h4>Let Russia Flabbergast you!</h4>
                    <p>
                      If your heart is headed in the direction of Russia here we
                      are to enlighten you about the beautiful facts of this
                      country, so let’s start. Russia is the world’s largest and
                      one of the most beautiful country for a spectator, this
                      country’s area str{" "}
                    </p>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box
                    style={{
                      position: "relative",
                      marginTop: "13px",
                      right: "25%",
                    }}
                  >
                    <img
                      src="https://www.marinersforex.com/img/Russia.png"
                      style={{
                        // width: '300px',
                        height: "150px",
                        padding: "15px 15px 15px 14px",
                        borderRadius: "32px",
                      }}
                    />
                    <img
                      src="https://www.marinersforex.com/img/1.jpg"
                      style={{
                        height: "150px",
                        padding: "15px 15px 15px 14px",
                        borderRadius: "32px",
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container>
              <Grid item xs={4}>
                  <Box
                    style={{
                      position: "relative",
                      marginTop: "13px",
                      left: "25%",
                    }}
                  >
                    <img
                      src="https://www.marinersforex.com/img/Russia.png"
                      style={{
                        // width: '300px',
                        height: "150px",
                        padding: "15px 15px 15px 14px",
                        borderRadius: "32px",
                      }}
                    />
                    <img
                      src="https://www.marinersforex.com/img/1.jpg"
                      style={{
                        height: "150px",
                        padding: "15px 15px 15px 14px",
                        borderRadius: "32px",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={8}
                  style={{
                    border: "2px solid #dfdfdf",
                    // padding: "10px 65px 10px 10px",
                    borderRadius: 9,
                  }}
                >
                  <Box style={{padding:30}}>
                    <h4>Let Russia Flabbergast you!</h4>
                    <p>
                      If your heart is headed in the direction of Russia here we
                      are to enlighten you about the beautiful facts of this
                      country, so let’s start. Russia is the world’s largest and
                      one of the most beautiful country for a spectator, this
                      country’s area str{" "}
                    </p>
                  </Box>
                </Grid>
               
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Carousel>
  );
};

export default CarouselBottom;
